import { css as e } from "@microsoft/fast-element";
import { normalize as l } from "../../common/normalize.js";
import { display as r } from "@matrix42/fast-foundation";
import { typography as t } from "../../styles/typography.js";
import { designTokens as o } from "../../design-tokens.js";
const y = e`
  ${l}
  ${r("flex")}
  .control {
    /* Layout */
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  :host {
    /* Layout */
    align-items: center;

    /* Typography */
    ${t("p", "regular")}
  }

  .step-container {
    /* Layout */
    display: flex;
    flex-direction: column;
    gap: ${o.spacing[10]};
  }

  .step-head {
    display: flex;
    flex-direction: column;
    gap: ${o.spacing[2]};
  }

  .step-label {
    /* Layout */
    text-align: left;

    /* Style */
    color: ${o.color.neutral[500]};

    /* Typography */
    ${t("h5", "semibold")}
  }

  .step-content {
    /* Layout */
    text-align: left;
  }
`;
export {
  y as stepStyles
};
